import { render, staticRenderFns } from "./ListClientsSection.vue?vue&type=template&id=ab583ae2&scoped=true&"
import script from "./ListClientsSection.vue?vue&type=script&lang=js&"
export * from "./ListClientsSection.vue?vue&type=script&lang=js&"
import style0 from "./ListClientsSection.vue?vue&type=style&index=0&id=ab583ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab583ae2",
  null
  
)

export default component.exports